import { Typography, Alert, Box, Chip } from '@mui/material';
import { ClipLoader } from 'react-spinners';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { BASE_URL, stripeConnectApi, stripeDisconnectApi, paypalConnectApi, paypalDisconnectApi } from '../../utils/Constants';

const StripeConnect = ({ profile }) => {
    const [loadingStripe, setLoadingStripe] = useState(false);
    const [loadingPayPal, setLoadingPaypal] = useState(false);
    const [stripeError, setStripeError] = useState('');
    const [paypalError, setPaypalError] = useState('');
    const [stripeStatus, setStripeStatus] = useState(false)
    const [paypalStatus, setPaypalStatus] = useState(false)

    useEffect(() => {
        if (profile && profile?.isStripeConnected) {
            setStripeStatus(true)
        }
        if (profile && profile?.isPaypalConnected) {
            setPaypalStatus(true)
        }
    }, [profile?.isStripeConnected, profile?.isPaypalConnected, setStripeStatus, profile, setPaypalStatus]);

    const handleStripeConnectClick = async () => {
        const token = localStorage.getItem('Token');
        if (!token) {
            setStripeError('Authorization token not found. Please log in again.');
            return;
        }

        const headers = {
            Authorization: token,
            'Content-Type': 'application/json',
        };

        setLoadingStripe(true);
        setStripeError('');

        try {
            if (!stripeStatus) {
                const { data } = await axios.post(`${BASE_URL}${stripeConnectApi}`, {}, { headers });
                if (data?.data?.url) {
                    window.location.href = data.data.url;
                } else {
                    setStripeError('Failed to get Stripe URL. Please try again.');
                }
            } else {
                const { data } = await axios.post(`${BASE_URL}${stripeDisconnectApi}`, {}, { headers });
                if (data?.status === 1) {
                    setStripeStatus(false);
                } else {
                    setStripeError('Disconnection failed. Please try again.');
                }
            }
        } catch (error) {
            console.error('Stripe action failed:', error);
            setStripeError('An error occurred. Please try again later.');
        } finally {
            setLoadingStripe(false);
        }
    };
    const handlePaypalConnectClick = async () => {
        const token = localStorage.getItem('Token');
        if (!token) {
            setPaypalError('Authorization token not found. Please log in again.');
            return;
        }

        const headers = {
            Authorization: token,
            'Content-Type': 'application/json',
        };

        setLoadingPaypal(true);
        setPaypalError('');

        try {
            if (!paypalStatus) {
                const { data } = await axios.post(`${BASE_URL}${paypalConnectApi}`, {}, { headers });
                if (data?.data?.url) {
                    window.location.href = data.data.url;
                } else {
                    setPaypalError('Failed to get Paypal URL. Please try again.');
                }
            } else {
                const { data } = await axios.post(`${BASE_URL}${paypalDisconnectApi}`, {}, { headers });
                if (data?.status === 1) {
                    setPaypalStatus(false);
                } else {
                    setPaypalError('Disconnection failed. Please try again.');
                }
            }
        } catch (error) {
            console.error('Paypal action failed:', error);
            setPaypalError('An error occurred. Please try again later.');
        } finally {
            setLoadingPaypal(false);
        }
    };

    return (
        <Box className="container" sx={{ padding: '2rem', paddingTop: '0.5rem' }}>
            {/* <Typography variant="body1" sx={{ color: '#555', lineHeight: 1.6, marginBottom: '1.5rem' }}>
                <strong>Important:</strong> Please connect your <span style={{color: "#30e6d4ff", padding: "0 2px"}}>Stripe</span> or <span style={{color: "#30e6d4ff", padding: "0 2px"}}>Paypal</span> account. Stripe and Paypal is our secure payment
                processing partner. Without connecting, payouts will not be possible. After connecting, payments will be automatically transferred as per our payout schedule. You can also disconnect anytime.
            </Typography> */}

            <Typography variant="body1" sx={{ color: '#555', lineHeight: 1.6, marginBottom: '1.5rem' }}>
                <strong>Important:</strong> Please connect your <span style={{color: "#30e6d4ff", padding: "0 2px"}}>Stripe</span> account. Stripe is our secure payment
                processing partner. Without connecting, payouts will not be possible. After connecting, payments will be automatically transferred as per our payout schedule. You can also disconnect anytime.
            </Typography>

            <Box sx={{ border: '1px solid #ddd', borderRadius: 2, p: 3, mb: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="h6">Stripe</Typography>
                    <Chip
                        label={stripeStatus ? "Connected" : "Not Connected"}
                        sx={{
                            backgroundColor: stripeStatus ? "#f5ec50" : "#d8d6d6ff",
                            color: "#000",
                        }}
                    />
                </Box>
                <Typography variant="body2" sx={{ color: '#555', mb: 2 }}>
                    Connect your Stripe account to receive payouts. Clicking “Connect” will redirect you to Stripe’s secure portal.
                </Typography>
                {stripeError && <Alert severity="error" sx={{ mb: 2 }}>{stripeError}</Alert>}
                <Button
                    variant="contained"
                    color={stripeStatus ? "secondary" : "primary"}
                    onClick={handleStripeConnectClick}
                    disabled={loadingStripe || loadingPayPal}
                >
                    {loadingStripe ? <ClipLoader size={16} color="#fff" /> : stripeStatus ? "Disconnect" : "Connect"}
                </Button>
            </Box>

            {/* <Box sx={{ border: '1px solid #ddd', borderRadius: 2, p: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="h6">PayPal</Typography>
                    <Chip
                        label={paypalStatus ? "Connected" : "Not Connected"}
                        sx={{
                            backgroundColor: paypalStatus ? "#f5ec50" : "#d8d6d6ff",
                            color: "#000",
                        }}
                    />
                </Box>
                <Typography variant="body2" sx={{ color: '#555', mb: 2 }}>
                    Connect your PayPal account to receive payouts. Clicking “Connect” will redirect you to PayPal’s secure portal.
                </Typography>
                {paypalError && <Alert severity="error" sx={{ mb: 2 }}>{paypalError}</Alert>}
                <Button
                    variant="contained"
                    color={paypalStatus ? "secondary" : "primary"}
                    onClick={handlePaypalConnectClick}
                    disabled={loadingStripe || loadingPayPal}
                >
                    {loadingPayPal ? <ClipLoader size={16} color="#fff" /> : paypalStatus ? "Disconnect" : "Connect"}
                </Button>
            </Box> */}

            <Typography variant="body1" sx={{ color: '#555', lineHeight: 1.6, marginBottom: '1.5rem' }}>
                <br />
                {/* <em>Note: Connecting to Stripe and Paypal is mandatory to receive any payments via this platform.</em> */}
                <em>Note: Connecting to Stripe is mandatory to receive any payments via this platform.</em>
            </Typography>
        </Box>
    );
};

export default StripeConnect;
